"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
var _default = {
  name: 'Home',
  data: function data() {
    return {};
  },
  created: function created() {}
};
exports.default = _default;